import type { ComponentProps } from "react";
import { t } from "ttag";

import { FullscreenAlert, PhoneIcon } from "@/shared/ui";

type ProviderCallModalProps = ComponentProps<typeof FullscreenAlert.Root> & {
  onContinue: VoidFunction;
};

/**
 * Shown after payment when the created subscription is WhiteCoat and the visit
 * requires a synchronous (phone) consultation, mirroring the portal message
 * displayed when submitting a WhiteCoat intake form that needs a sync visit.
 */
export const ProviderCallModal = ({
  onContinue,
  ...props
}: ProviderCallModalProps) => (
  <FullscreenAlert.Root {...props}>
    <FullscreenAlert.Content theme="light">
      <FullscreenAlert.Header icon={PhoneIcon}>
        <FullscreenAlert.Title>
          {t`Phone consultation required`}
        </FullscreenAlert.Title>

        <FullscreenAlert.Description>
          {t`Based on your state's requirements, a phone consultation is required before starting treatment. You'll receive a call from one of our providers to complete your visit. Keep an eye out - we'll be in touch soon!`}
        </FullscreenAlert.Description>
      </FullscreenAlert.Header>

      <FullscreenAlert.Footer>
        <FullscreenAlert.Action onClick={onContinue}>
          {t`Continue`}
        </FullscreenAlert.Action>
      </FullscreenAlert.Footer>
    </FullscreenAlert.Content>
  </FullscreenAlert.Root>
);
